'use client'

import s from './Footer.module.scss';
import {Link} from '@/i18n/routing';
import {LogoIcon} from "@/app/[locale]/common/assets/LogoIcon/LogoIcon";
import {CONTACT_INFO} from "../../constants/main";
import {Line} from "@/app/[locale]/common/components/Line/Line";
import {PhoneIcon} from "@/app/[locale]/common/assets/PhoneIcon/PhoneIcon";
import {EmailIcon} from "@/app/[locale]/common/assets/EmailIcon/EmailIcon";
import {FooterColumn} from "@/app/[locale]/common/components/Footer/FooterColumn";
import {FacebookIcon} from "@/app/[locale]/common/assets/FacebookIcon/FacebookIcon";
import {WhatsAppIcon} from "@/app/[locale]/common/assets/WhatsAppIcon/WhatsAppIcon";
import {formatSectionData} from "@/app/[locale]/common/utils/formatSectionData/formatSectionData";
import {APP_ROUTES} from "../../constants/app";
import {useTranslations} from "next-intl";

export const Footer = () => {
    const t = useTranslations('Footer');
    const data = formatSectionData(t.raw('aboutUs.data'), t.raw('industries.data'), t.raw('products.data'), t.raw('solutions.data'), t.raw('services.data'), t);

    return (
        <footer className={s.footer}>
            <div className={s.footer_container}>
                <div className={s.footer_contentContainer}>
                    <div className={s.footer_content_column}>
                        <Link href={APP_ROUTES.MAIN} className={s.footer_logo}>
                            <LogoIcon type={'dark'}/>
                        </Link>
                        <div className={s.footer_content_social}>
                            <Link href={'https://www.facebook.com/profile.php?id=61560301253692&mibextid=wwXIfr'} className={s.footer_logo}>
                                <FacebookIcon/>
                            </Link>
                            <Link href={'#'} className={s.footer_logo}>
                                <WhatsAppIcon/>
                            </Link>
                        </div>
                        <div className={s.footer_content_address}>
                            <label>Address</label>
                            <p>{CONTACT_INFO.ADDRESS}</p>
                        </div>
                        <div className={s.footer_content_contact}>
                            <label>{t('contact')}</label>
                            <Link href={'tel:+639985509738'} className={s.footer_content_contact_link}>
                                <PhoneIcon color={'white'}/> { CONTACT_INFO.PHONE }
                            </Link>

                            <Link href={`mailto:${CONTACT_INFO.EMAIL}`} className={s.footer_content_contact_link}>
                                <EmailIcon color={'white'}/>{ CONTACT_INFO.EMAIL }
                            </Link>
                        </div>
                    </div>

                    <FooterColumn data={data.about}/>
                    <FooterColumn data={data.industries}/>
                    {/*<FooterColumn data={data.products}/>*/}
                    <FooterColumn data={data.solutions}/>
                    <FooterColumn data={data.services}/>
                </div>
                <div className={s.footer_bottomContent}>
                    <Line/>
                    <div className={s.footer_bottomContent_privacy}>
                        <p>{ t('bottomContent.copyright') }</p>
                        <Link href={'/privacy-police'}>{ t('bottomContent.privacy') }</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};